import axiosInstance from "./axiosInstance";
import {
  FilterPayload, SavedFilter, UpdateFilterPayload } from "../types/filterTypes";

export const getFiltersApi = async (
  userEmail: any,
  tableName: string,
): Promise<SavedFilter[]> => {
  try {
    const response = await axiosInstance.get(
      `/api/admin/filters/user/${encodeURIComponent(
        userEmail,
      )}/${encodeURIComponent(tableName)}`,
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching filters:", error);
    throw error;
  }
};

export const createFilterApi = async (
  payload: FilterPayload,
): Promise<SavedFilter> => {
  try {
    const response = await axiosInstance.post(
      "/api/admin/filters",
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Error creating filter:", error);
    throw error;
  }
};

export const updateFilterApi = async (
  payload: UpdateFilterPayload,
): Promise<SavedFilter> => {
  try {
    const response = await axiosInstance.post(
      `/api/admin/filters/update`,
      payload,
    );

    return response.data;
  } catch (error) {
    console.error("Error updating filter:", error);
    throw error;
  }
};

export const deleteFilterApi = async (
  filterId: number,
): Promise<void> => {
  try {
    await axiosInstance.delete(
      `/api/admin/filters/${filterId}`,
    );
  } catch (error) {
    console.error("Error deleting filter:", error);
    throw error;
  }
};